/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconChevronLeft, IconEye, IconX } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import ListView from "../../components/common/ListView";
import { useEffect, useState } from "react";
import {
  useDistrictFetchData,
  useFetchCountryCitiesDistrictsArrayData,
} from "../../apis/locationApis";
import formatDate from "../../utilities/helper";
import ViewCoverageCitiesSkeleton from "../../components/skeleton/ViewCoverageCitiesSkeleton";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
import NoDataFound from "../../components/common/NoDataFound";
export default function ViewDistrictDetails() {
  const Section = ({
    title,
    children,
  }: {
    title: string;
    children: React.ReactNode;
  }) => (
    <div className="border border-[#d2d2d2] rounded-[20px] bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]">
      <h2 className="text-[#212121]/70 font-medium text-sm">{title}</h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-x-12 gap-y-4">
        {children}
      </div>
    </div>
  );
  const [districtData, setDistrictData] = useState<any[]>([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { warehouseName, covrage, cityId, countryName, cityName, createdAt } =
    location.state || {};
  const {
    data: districtDataList,
    isPending: districtPending,
    refetch: districtDataRefetch,
  } = useFetchCountryCitiesDistrictsArrayData(covrage);
  const {
    data,
    isPending,
    refetch: districtRefetch,
  } = useDistrictFetchData(cityId);
  useEffect(() => {
    if (covrage?.length > 0) {
      districtDataRefetch();
    } else {
      districtRefetch();
    }
  }, [covrage]);

  const [showAliasModal, setShowAliasModal] = useState(false);
  const [aliasData, setAliasData] = useState<{ en: string[]; ar: string[] }>({
    en: [],
    ar: [],
  });

  useEffect(() => {
    setDistrictData([]);
    if (districtDataList?.length > 0) {
      setDistrictData(districtDataList);
    } else {
      setDistrictData(data);
    }
  }, [districtDataList, data]);
  return (
    <>
      <div className="p-4 pt-0 space-y-4 w-9/12 mx-auto">
        {/* Header */}
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            className="flex justify-center items-center rounded-full h-10 w-10 border-gray-300 border hover:bg-white transition"
          >
            <IconChevronLeft strokeWidth={1.5} size={22} />
          </button>
          <h1 className="text-xl tracking-[0.5px] text-[#212121] text-medium ">
            Coverage District
          </h1>
        </div>

        {/* Sections */}
        {districtData?.length === 0 ? (
          <TableSkeleton
            columns={districtData.filter((c) => c.isShow).map((c) => c.text)}
            rows={6}
          />
        ) : (
          <div className="space-y-4">
            <Section title=" ">
              <h1 className="text-[#212121] font-medium text-lg px-4 py-4 pb-0 whitespace-nowrap">
                {warehouseName} - {countryName} - {cityName}{" "}
              </h1>
              <div className="col-span-4">
                <ListView
                  mainDivClassName="bg-transparent p-0"
                  mailDivClassName="p-0 bg-transparent"
                  data={districtData}
                  onRowClick={(client) => console.log("Clicked:", client)}
                  columns={[
                    { label: "#", render: (_, i) => i + 1 },
                    {
                      label: "District Name",
                      render: (c: any) => (
                        <div className="w-40 overflow-hidden">{c.name}</div>
                      ),
                    },
                    {
                      label: "District Arabic",
                      render: (c: any) => (
                        <div className="w-40">{c.arabicName}</div>
                      ),
                    },
                    {
                      label: "Alias Name",
                      render: (c: any) => (
                        <button
                          onClick={() => {
                            setAliasData({
                              en: c.aliasEnglish || [],
                              ar: c.aliasArabic || [],
                            });
                            setShowAliasModal(true);
                          }}
                          className="text-blue-600 underline hover:text-blue-800"
                        >
                          View
                        </button>
                      ),
                    },
                    {
                      label: "Created Date",
                      render: (c: any) => (
                        <div className="flex justify-center">
                          {formatDate(createdAt)}
                        </div>
                      ),
                    },
                  ]}
                />
              </div>
            </Section>
          </div>
        )}
      </div>
      {showAliasModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-[#F7F6F2] rounded-3xl w-[500px] max-h-[76vh] flex flex-col  overflow-hidden">
            <div className="flex items-center justify-between px-4 py-3 border-b">
              <h2 className="text-lg font-medium text-[#212121]">
                Alias Names
              </h2>
              <button
                onClick={() => setShowAliasModal(false)}
                className="p-2 rounded-full border border-[#D2D2D2]"
              >
                <IconX size={20} />
              </button>
            </div>

            <div className="grid grid-cols-2">
              <div className="flex-1 overflow-y-auto hide-scrollbar px-4 py-2 border space-y-1">
                <h2> Alias Names (EN)</h2>
                {aliasData.en.length > 0 ? (
                  aliasData.en.map((a, index) => (
                    <div
                      key={`${a}-${index}`}
                      className={`flex items-center py-1 ${
                        aliasData.en.length > 999 ? "gap-2" : "gap-2"
                      }`}
                    >
                      <span className="h-8 w-8 flex justify-center items-center text-[#212121]/70 rounded-full border border-[#D2D2D2]">
                        {index + 1}
                      </span>
                      <p className="text-[#000000] text-base font-normal">
                        {a}
                      </p>
                    </div>
                  ))
                ) : (
                  <NoDataFound title="No Data Found" message="" />
                )}
              </div>
              <div className="flex-1 overflow-y-auto hide-scrollbar px-4 py-2 border space-y-1">
                <h2> Alias Names (AR)</h2>
                {aliasData.ar.length > 0 ? (
                  aliasData.ar.map((a, index) => (
                    <div
                      key={`${a}-${index}`}
                      className={`flex items-center py-1 ${
                        aliasData.ar.length > 999 ? "gap-2" : "gap-2"
                      }`}
                    >
                      <span className="h-8 w-8 flex justify-center items-center text-[#212121]/70 rounded-full border border-[#D2D2D2]">
                        {index + 1}
                      </span>
                      <p className="text-[#000000] text-base font-normal">
                        {a}
                      </p>
                    </div>
                  ))
                ) : (
                  <NoDataFound title="No Data Found" message="" />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
